import { FormControl, InputLabel } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CONFIG } from '../../../../config';
import { VIEW_MODE } from '../../../../consts/enums';
import STRING_KEYS from '../../../../language/keys';
import CustomTextField from '../../../CustomTextField';
import { style } from './style';

type SubdomainTextFieldProps = {
  onChange: (name: string, value: string) => void,
  subDomainFields: {
    error?: boolean,
    helperText?: string | false | undefined,
    value: string,
  },
  viewMode: ViewMode,
}

export const SubdomainTextField = ({
  onChange,
  subDomainFields,
  viewMode,
}: SubdomainTextFieldProps):JSX.Element => {
  const { t: translate } = useTranslation();
  const isReadOnly = viewMode === VIEW_MODE.READ_ONLY;

  return (
    <FormControl
      fullWidth
      variant={ isReadOnly ? 'standard' : 'outlined' }
    >
      <CustomTextField
        sx={ style.Typography }
        id="subdomain"
        variant="outlined"
        viewMode={ viewMode }
        label={ translate(STRING_KEYS.ACCOUNTS_SUBDOMAIN) }
        value={
          isReadOnly ?
            subDomainFields.value + CONFIG.SUBDOMAIN_NAME : subDomainFields.value
        }
        error={ subDomainFields?.error }
        inputProps={ {
          maxLength: 30,
        } }
        helperText={ subDomainFields?.error ?
          subDomainFields.helperText : '' }
        onChange={ (e) => onChange('subDomainName', e.target.value) }
        margin="normal"
        name="subDomainName"
      />
      {!isReadOnly && (
        <InputLabel htmlFor="subdomain"
          sx={ style.inputLabel }
        >
          {CONFIG.SUBDOMAIN_NAME}
        </InputLabel>
      )}
    </FormControl>
  );
};
